import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrl: './data-grid.component.scss',
  standalone: false,
})
export class DataGridComponent {
  @Input() public set data(value: any[]) {
    this.alldata = value ?? [];
    this.calculateTotalPages();
    this.selectedPage = Math.min(this.selectedPage, Math.max(0, this.totalPages - 1));
    this.loadPageData(this.selectedPage + 1);
    setTimeout(() => {
      this.showPaginator = true;
    });
  }
  @Input() public columns: any[] = []; // Array of column definitions (objects with header and key)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() public eventHandler: EventEmitter<{
    item: any;
    action: string;
  }> = new EventEmitter();
  @Input() public alldata: any[] = [];
  public itemsPerPage: number = 10;
  public currentPageData: any[] = []; // Data to show on the current page
  public currentPageStartIndex: number = 0;
  public totalPages: number = 0;
  public selectedPage: number = 0;
  public showPaginator: boolean = true;
  sortDirection: 'asc' | 'desc' = 'desc';
  public calculateTotalPages(): void {
    this.totalPages = Math.ceil(this.alldata.length / this.itemsPerPage);
  }

  public loadPageData(page: number): void {
    this.selectedPage = Math.max(0, Math.min(page - 1, this.totalPages - 1));
    const startIndex: number = this.selectedPage * this.itemsPerPage;
    const endIndex: number = startIndex + this.itemsPerPage;
    this.currentPageStartIndex = startIndex;
    this.currentPageData = this.alldata.slice(startIndex, endIndex);
  }
  // Event handler when page is changed
  public onPageChange(page: CustomEvent): void {
    this.loadPageData(page.detail + 1);
  }

  public onItemCountChanged(event: CustomEvent): void {
    this.itemsPerPage = event.detail;
    this.selectedPage = 0;
    this.loadPageData(1);
    this.calculateTotalPages();
  }

  public cardAction(row: any, action: string): void {
    this.eventHandler.emit({ item: row, action: action });
  }

  public isArray(value: any): boolean {
    return Array.isArray(value);
  }

  formatValue(value: any, path?: string): string {
    if (typeof value === 'string') {
      return value === '' ? '--' : value;
    }

    if (Array.isArray(value)) {
      if (value.length > 0 && typeof value[0] === 'object' && path) {
        return value.map((item) => this.getNestedValue(item, path)).join(', ');
      }
      return value.length > 0 ? value.join(', ') : '--';
    }

    if (typeof value === 'object' && value !== null && path) {
      return this.getNestedValue(value, path);
    }
    return value ?? '--';
  }

  getNestedValue(obj: any, path: string): string {
    return path.split('.').reduce((acc, part) => acc?.[part], obj) ?? '--';
  }

  sortBy(field: string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.alldata = [];
    this.eventHandler.emit({ item: field, action: this.sortDirection });
  }

  ngOnDestroy() {
    this.selectedPage = 0;
  }
}
